import styled, { css } from 'styled-components';

export const Div = styled.div<{ showHistory: boolean }>`
  margin-top: 28px;
  display: inline-block;

  .button {
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;

    span {
      margin-right: 7px;
      text-decoration: underline;
    }

    svg {
      ${({ showHistory }) =>
        showHistory &&
        css`
          transform: rotate(180deg);
        `};
    }
  }
`;
